var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inputBox"},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":_vm.size},on:{"input":_vm.input},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }